module.exports = __webpack_public_path__ + "static/media/dhl.53cc2d6d.svg";